function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 2.8c0-.1-6.07 6.19-6 6.15h1.62L9 4.18zM9.1 5.63S5.77 8.96 5.79 8.97h3.3zM9.13 0L0 8.97h1.59c0 .07 7.46-7.51 7.53-7.51z"
});

var SvgResizableHandle = function SvgResizableHandle(props) {
  return React.createElement("svg", _extends({
    "data-name": "Capa 1",
    viewBox: "0 0 9.13 9"
  }, props), _ref);
};

export default SvgResizableHandle;